/* RemixShare.js */
/* @author: anghello */

import React, { useCallback, Fragment, useEffect, useState } from 'react';
import { Button, Col, Row, UncontrolledButtonDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap';
import { IoIosLink, IoIosCode, IoIosMail, IoLogoFacebook, IoLogoTwitter, IoMdGlobe } from 'react-icons/io';
import Strings from '../../translations/Translations';
import { copyTextToClipboard } from '../../helpers/CopyTextToClipboard';
import { toast } from 'react-toastify';
import { getShareOptions } from '../../helpers/GetShareOptions';
import PSO from '../../services/PSO';
import { useAuth } from '../../context/auth/AuthContext';

// const PUBLIC_VIDEOS_URL = process.env.REACT_APP_PUBLIC_VIDEOS;
const PUBLIC_VIDEOS_URL_POPFANS = process.env.REACT_APP_PUBLIC_VIDEOS_POPFANS;
const SHARE_OPTIONS = getShareOptions();
const REMIX_URL = process.env.REACT_APP_PZ_REMIX_URL;
const EMBEDDED_PLUGIN_URL = process.env.REACT_APP_EMBEDDED_PLUGIN_FRAME;

export default function RemixShare({ remix, groupButtons = true, align = 'left', btnClass = '' }) {
  const { authenticated } = useAuth();
  const [remixPars, setRemixPars] = useState();
  const socialIconsColor = '#000000';

  const getUrl = useCallback(() => {
    let url = '';
    if (remixPars && remixPars.tid) {
      const { tid } = remixPars;
      let videosURL = PUBLIC_VIDEOS_URL_POPFANS;
      url = `${videosURL}+${tid}`;
    }
    return url;
  }, [remixPars]);

  const onClickOpenLink = useCallback(() => {
    if (remixPars) {
      window.open(getUrl(), '_blank');
    }
  }, [remixPars, getUrl]);

  const onClickCopyLink = useCallback(async () => {
    if (remixPars) {
      await copyTextToClipboard(getUrl());
      toast.success(Strings('url_copied_to_clipboard'));
    }
  }, [remixPars, getUrl]);

  const onClickEmbededCode = useCallback(async () => {
    if (remixPars) {
      const { rid } = remixPars;
      let iframe = `<iframe id="${rid}" width="640" height="360" src="${EMBEDDED_PLUGIN_URL}?remixid=${rid}&nooverbottomstartag?noovertopstartag?refreshonrestartbtn" title="Pepblast Player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
      await copyTextToClipboard(iframe);
      toast.success(Strings('url_copied_to_clipboard'));
    }
  }, [remixPars]);

  const onClickEmail = useCallback(() => {
    if (remixPars) {
      const { rti, rown } = remixPars;
      const subject = encodeURIComponent(`Link Page: ${rti}`);
      const description = encodeURIComponent(`Check this Link Page out: \n\n ${getUrl()} \n\nLink Page created by ${rown} at: ${REMIX_URL}`);
      const mail = `mailto:?subject=${subject}&body=${description}`;
      window.open(mail, '_blank');
    }
  }, [remixPars, getUrl]);

  const onClickSocialFacebook = useCallback(() => {
    if (remixPars) {
      const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(getUrl())}`;
      window.open(url, '_blank');
    }
  }, [remixPars, getUrl]);

  const onClickSocialTwitter = useCallback(() => {
    if (remixPars) {
      const url = `https://twitter.com/intent/tweet?hashtags=PepBlast&text=${remixPars.rti} (by ${remixPars.rown})&tw_p=tweetbutton&url=${encodeURIComponent(getUrl())}`;
      window.open(url, '_blank');
    }
  }, [remixPars, getUrl]);

  const getRemixPars = useCallback(async (rid) => {
    try {
      const response = await PSO.getRemixPars({
        un: authenticated.un,
        al: authenticated.al,
        rid: rid
      });
      if (response.result === 'success' && response.its && response.its.length > 0) {
        setRemixPars(response.its[0]);
      }
    } catch (err) {
      console.error(Strings('general_error'));
    }
  }, [setRemixPars, authenticated]);
  useEffect(() => { if (remix && remix.rid) { getRemixPars(remix.rid); } }, [remix, getRemixPars]);

  return (
    <Row>
      <Col>

        <div className={`${(groupButtons) ? 'btn-group' : ''} ${(align === 'center') ? 'text-center' : ''}`}>
          <Button className={`pb-btn-1 ${btnClass}`} onClick={onClickOpenLink}>
            <IoMdGlobe color='#ffffff' style={{ marginRight: '4px' }} />
            <span>
              {Strings('open')}
            </span>
          </Button>

          <Button className={`pb-btn-1 ${btnClass}`} onClick={onClickCopyLink}>
            <IoIosLink color='#ffffff' style={{ marginRight: '4px' }} />
            <span>
              {Strings('copy_link')}
            </span>
          </Button>

          {SHARE_OPTIONS.EMBED_CODE && (
            <Fragment>
              <Button className={`pb-btn-1 ${btnClass}`} onClick={onClickEmbededCode}>
                <IoIosCode color='#ffffff' style={{ marginRight: '4px' }} />
                <span>
                  {Strings('embeded_code')}
                </span>
              </Button>
            </Fragment>
          )}

          {SHARE_OPTIONS.EMAIL && (
            <Button className={`pb-btn-1 ${btnClass}`} onClick={onClickEmail}>
              <IoIosMail color='#ffffff' style={{ marginRight: '4px' }} />
              <span>
                {Strings('email')}
              </span>
            </Button>
          )}

          <UncontrolledButtonDropdown>
            <DropdownToggle caret className={`pb-btn-1 ${btnClass}`}>
              {Strings('social_share')}
            </DropdownToggle>
            <DropdownMenu>
              {SHARE_OPTIONS.FACEBOOK && (
                <DropdownItem
                  onClick={onClickSocialFacebook}
                >
                  <span className="mr-2">{Strings('facebook')}</span> <IoLogoFacebook color={socialIconsColor} size={20} />
                </DropdownItem>
              )}
              {SHARE_OPTIONS.TWITTER && (
                <DropdownItem
                  onClick={onClickSocialTwitter}
                >
                  <span className="mr-2">{Strings('twitter')}</span> <IoLogoTwitter color={socialIconsColor} size={20} />
                </DropdownItem>
              )}
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </div>

      </Col>
    </Row>
  );
}
